import { LOOKUP } from "../definitions";

const lookupReducer = (state = { lookup: [] }, action) => {
  switch (action.type) {
    case LOOKUP.START_FETCH: {
      return {
        lookup: [],
      };
    }
    case LOOKUP.FINISH_FETCH: {
      return {
        lookup: action.payload,
        error: "",
      };
    }
    case LOOKUP.FAIL_FETCH: {
      return {
        error: action.payload,
      };
    }
    default:
      return state;
  }
};

export { lookupReducer };
